import NestedResourcesLayout from './NestedResourcesLayout'
export default NestedResourcesLayout
